export const errorCodes = {
    accountNotFound: 7,
    billingNumberNotFound: 16
}

export const httpStatusCode = {
    OK: 200,
    badRequest: 400,
    forbidden: 403,
    notFound: 404,
    notAcceptable: 406,
    internalServerError: 500,
    badGateway: 502,
    serviceUnavailable: 503,
}